







































import {
  defineComponent, ref, onMounted,
} from '@nuxtjs/composition-api';
import { SfImage } from '~/components/StorefrontUi';

import { useUiHelpers } from '~/composables';
import { addBasePath } from '~/helpers/addBasePath';
import type {
  CategoryTree,
} from '~/modules/GraphQL/types';
import type { PropType } from '@nuxtjs/composition-api';
import CategorySubSubChildFilters from './CategorySubSubChildFilters.vue';

export default defineComponent({
  name: 'CategorySubChildFilters',
  components: {
    CategorySubSubChildFilters,
    SfImage,
  },
  props: {
    childCategory: {
      type: Object as PropType<CategoryTree>,
      required: true,
    },
    activeCategoryValidator: {
      type: Function as PropType<(uid: string) => boolean>,
      default: () => () => false,
    },
    categoryAncestorsUids: {
      type: Array as PropType<string[]>,
      default: () => [],
    },
  },
  setup(props) {
    const { getCatLink } = useUiHelpers();
    const curentSubSubChildUid = ref('');
    const toggleSubSubChildCategories = (uid: string) => {
      curentSubSubChildUid.value = curentSubSubChildUid.value === uid ? '' : uid;
    };

    onMounted(() => {
      if (props.categoryAncestorsUids.length > 3) {
        // eslint-disable-next-line
        curentSubSubChildUid.value = props.categoryAncestorsUids[2];
      }
    });

    return {
      getCatLink,
      curentSubSubChildUid,
      toggleSubSubChildCategories,
      addBasePath,
    };
  },
});
